/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { DxpScreen } from '../../Components/DxpScreen/DxpScreen';
import { DXP_SCREEN_LAYOUT_WIDE } from '../../Components/DxpScreen/types/DxpScreenLayout.types';
import { DXP_SCREEN_STRUCTURE_FULL } from '../../Components/DxpScreen/types/DxpScreenStructure.types';
import { LoginBanner } from './elements/LoginBanner/LoginBanner';
import { LoginForm } from './elements/LoginForm/LoginForm';

/**
 * DXP Login Screen.
 */
export const DxpLogin = (): JSX.Element => {
  const screenHeading = ``;
  const screenContent = (
    <div className="user-management-columns">
      <LoginBanner />
      <LoginForm />
    </div>
  );

  return (
    <DxpScreen heading={screenHeading} layout={DXP_SCREEN_LAYOUT_WIDE} structure={DXP_SCREEN_STRUCTURE_FULL}>
      {screenContent}
    </DxpScreen>
  );
};
